// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactSupport_wrapper__SnVaL","title":"ContactSupport_title__Uyt8-"};